import { TRANSLATIONS, TRANSLATIONS_FORMAT, LOCALE_ID, MissingTranslationStrategy } from '@angular/core';
import { CompilerConfig } from '@angular/compiler';
import { environment } from '@app/env';
declare const ActiveXObject;

export function getTranslationProviders(): Promise<Object[]> {
  // Get the locale id from the global
  const locale = environment.langShort === 'ET' ? 'et-EE' : environment.langShort === 'EN' ? 'en-GB' : environment.langShort;

  // return no providers if fail to get translation file for locale
  const noProviders: Object[] = [];

  // Ex: 'locale/messages.es.xlf`
  const translationFile = `/locale/messages.${locale}.xtb`;

  return getTranslationsFromFile(translationFile)
    .then((translations: string) => [
      { provide: TRANSLATIONS, useValue: translations },
      { provide: TRANSLATIONS_FORMAT, useValue: 'xtb' },
      { provide: LOCALE_ID, useValue: locale }
    ])
    .catch(() => noProviders); // ignore if file not found
}

/*
    Get translation file contents using Primisified XMLHttpRequest
 */
function getTranslationsFromFile(file: string) {
  return new Promise((resolve, reject) => {
    let xhttp;

    if ((<any>window).XMLHttpRequest) {
      xhttp = new XMLHttpRequest();
    } else {
      xhttp = new ActiveXObject('Microsoft.XMLHTTP');
    }

    xhttp.onload = () => {
      if (xhttp.readyState == 4 && xhttp.status >= 200 && xhttp.status < 300) {
        resolve(xhttp.response);
      } else {
        reject({
          status: xhttp.status,
          statusText: xhttp.statusText
        });
      }
    };

    xhttp.open('GET', file, true);
    xhttp.send();
  });
}
